import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowRight } = FiIcons;

const FinalCTA = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800 text-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="space-y-8"
        >
          <h2 className="text-4xl lg:text-6xl font-bold">
            Get Protected <span className="block text-blue-400">Today</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Don't wait. Every day without coverage puts your business at risk.
          </p>
          <div className="flex justify-center">
            <motion.a
              href="https://quote.burbankinsuranceservices.com/Jn9lan"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-xl font-semibold text-lg flex items-center justify-center space-x-3 transition-colors duration-300"
            >
              <span>Get Quote Now</span>
              <SafeIcon icon={FiArrowRight} />
            </motion.a>
          </div>
          <div className="text-center pt-8">
            <p className="text-sm text-gray-500">
              Licensed in California • CA License #6013543
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;